import { ConfigFilterItem, ConfigItem, DefaultFile, MultipleDefaultFile } from 'Core/interfaces'

export enum InvoiceBasicFields {
	invoiceId = 'invoiceId',
	invoiceDocument = 'invoiceDocument',
	status = 'status',
	supplierLocation = 'supplierLocation',
	supplierInvoiceNumber = 'supplierInvoiceNumber',
	invoiceDate = 'invoiceDate',
	currency = 'currency',
	checkAmount = 'checkAmount',
	checkNumber = 'checkNumber',
	checkDate = 'checkDate',
	paidAmount = 'paidAmount',
	scheduledPayDate = 'scheduledPayDate',
	invoiceAmount = 'invoiceAmount'
}

export enum InvoiceMainSearchFields {
	supplierInvoiceNumber = 'supplierInvoiceNumber'
}

export enum InvoiceFilterFields {
	endInvoiceDate = 'endInvoiceDate',
	startInvoiceDate = 'startInvoiceDate',
	supplierLocationId = 'supplierLocationId',
	status = 'status'
}

export enum InvoiceStatusLabel {
	sent = 'sent',
	cancelled = 'cancelled',
	inProgress = 'in progress',
	approved = 'approved',
	paid = 'paid'
}

export enum InvoiceStatusFilterValue {
	sent = 'sent',
	cancelled = 'cancelled',
	inProgress = 'inProgress',
	approved = 'approved',
	paid = 'paid'
}

export declare namespace Invoice {
	interface Basic {
		[InvoiceBasicFields.invoiceId]: number
		[InvoiceBasicFields.invoiceDocument]: Entity | null
		[InvoiceBasicFields.supplierInvoiceNumber]: BasicString
		[InvoiceBasicFields.status]: InvoiceStatusLabel | null
		[InvoiceBasicFields.supplierLocation]: Entity | null
		[InvoiceBasicFields.invoiceDate]: BasicString
		[InvoiceBasicFields.currency]: CodeEntity | null
		[InvoiceBasicFields.checkNumber]: BasicString
		[InvoiceBasicFields.checkDate]: BasicString
		[InvoiceBasicFields.paidAmount]: number | null
		[InvoiceBasicFields.scheduledPayDate]: BasicString
		[InvoiceBasicFields.invoiceAmount]: BasicNumber
	}

	namespace Search {
		interface Config {
			[InvoiceMainSearchFields.supplierInvoiceNumber]: ConfigItem<InvoiceMainSearchFields>
		}

		interface Result {
			[InvoiceMainSearchFields.supplierInvoiceNumber]: string[]
		}
	}

	namespace Filter {
		interface Config {
			[InvoiceFilterFields.startInvoiceDate]: ConfigFilterItem<string, null>
			[InvoiceFilterFields.endInvoiceDate]: ConfigFilterItem<string, null>
			[InvoiceFilterFields.supplierLocationId]: ConfigFilterItem<string, string>
			[InvoiceFilterFields.status]: ConfigFilterItem<string, string>
		}
	}

	namespace Edit {
		interface Check {
			checkAmount: number
			checkNumber: BasicString
			checkDate: BasicString
		}
		interface Basic {
			invoiceId: number
			invoiceDocument: Entity | null
			status: InvoiceStatusLabel
			supplierInvoiceNumber: BasicString
			supplierLocation: Entity | null
			checkNumber: BasicString
			invoiceDate: BasicString
			checkDate: BasicString
			scheduledPayDate: BasicString
			invoiceAmount: number
			paidAmount: number
			currency: CodeEntity | null
			invoiceCost: number
			shortPayCost: number
			shortPayReason: Entity | null
			supplierInvoiceComments: BasicString
			checks: Check[]
		}
		interface ShortPays {
			itemDescription: BasicString
			quantity: BasicNumber
			pounds: BasicNumber
			serviceDate: BasicString
			invoiceCost: BasicNumber
			shortPayCost: BasicNumber
			shortPayReason: Entity | null
		}
		namespace BackupDocument {
			interface Basic {
				id: number
				documentType: Entity | null
				documentName: BasicString
				dateUploaded: BasicString
			}
			namespace Form {
				interface Add {
					documentTypeId: Key | null
					files: MultipleDefaultFile
				}
			}
			namespace Request {
				interface Add {
					documentTypeId: Key | null
					Files: File[]
				}
			}
		}
	}

	namespace Add {
		namespace Form {
			interface Add {
				supplierLocationId: BasicNumber
				invoiceDocument: DefaultFile | null
			}
		}
		namespace Request {
			interface Add {
				supplierLocationId: BasicNumber
				InvoiceDocument: File | null
			}
		}
	}
}
